<!-- <div class="row">
    <div class="col-12 text-center">
        <p>Estamos felizes por você!</p>

        <p>Você pode ter acesso aos seus boletos a qualquer momento no site <a
                href="https://www.bancosemear.com.br">www.bancosemear.com.br</a> ou pelos canais de atendimento do
            SEMEAR:</p>

        <p>atendimento@bancosemear.com.br</p>
        <p>WhastApp 31 4000-1570</p>

        <p>Agora basta finalizar sua compra!</p>
    </div>
</div> -->

<div class="row mt-5">
    <div class="col-12 text-center">
        <h1>Quase lá!</h1>
    </div>

    <div class="col-12 d-flex justify-content-center mt-5 mb-5">
        <div class="img-feedback img-feedback-success"></div>
    </div>

    <div class="col-12 text-center mb-5">
        <p>Em alguns minutos, você receberá um SMS para finalizarmos o seu cadastro. Não se preocupe, essa próxima etapa
            é bem rápida.
            Aproveite esse tempinho para pegar o seu RG ou CNH, vamos precisar de uma foto do seu documento.</p>
    </div>
</div>

<div class="row fixed-bottom">
    <div class="col-12 text-center">
        <button class="btn btn-primary" (click)="close()">OK</button>
    </div>
</div>